import { useMapsLibrary as u } from "@vis.gl/react-google-maps";
import { useState as c, useEffect as s } from "react";
function n(t) {
  const e = u("places"), [r, o] = c(null);
  return s(() => {
    if (e)
      return o(
        new e.Autocomplete(t, { types: ["geocode"] })
      ), () => {
        o(null);
      };
  }, [e, t]), r;
}
export {
  n as useAutocompleteService
};
